export const COGNITO_GROUP_BI_PREMIACAO = 'bi-premiacao';

export const COGNITO_GROUP_CONFIGURACOES_LISTAGEM_GERAL = 'configuracoes-listagem-geral';

export const COGNITO_GROUP_CLIENTES = 'clientes';

export const COGNITO_GROUP_PREVISAO_CARGAS = 'previsao-cargas';

export const COGNITO_GROUP_CONTAINERS = 'containers';

export const COGNITO_GROUP_VEICULOS = 'veiculos';

export const COGNITO_GROUP_PEDIDOS = 'pedidos';

export const COGNITO_GROUP_VIAGENS = 'viagens';

export const COGNITO_GROUP_OPERACOES = 'operacoes';

export const COGNITO_GROUP_MOTORISTAS = 'motoristas';

export const COGNITO_GROUP_NOTIFICACOES = 'notificacoes';

export const COGNITO_GROUP_ACOMPANHAMENTOS = 'acompanhamentos';

export const COGNITO_GROUP_DESCARGA = 'descarga';

export const COGNITO_GROUP_DESCARGA_JANELA = 'descarga-janela';

export const COGNITO_GROUP_DEPOSITO = 'deposito';

export const COGNITO_GROUP_NOTIFICACOES_DESCARGA = 'notificacoes-descarga';

export const COGNITO_GROUP_CHAT_IA_PROGRAMACAO = 'chat-ia-programacao';

export const COGNITO_GROUP_CHAT_IA_PROGRAMACAO_HAVAN = 'chat-ia-programacao-havan';

/**
 * Extrai grupos do Cognito a partir do profile do usuário OIDC.
 * @param {object|null} user
 * @returns {string[]}
 */
export const getCognitoGroups = (user) => {
  if (!user?.profile) {
    return [];
  }

  const groups = user.profile['cognito:groups'];

  if (!groups) {
    return [];
  }

  if (Array.isArray(groups)) {
    return groups;
  }

  if (typeof groups === 'string') {
    return [groups];
  }

  return [];
};

/**
 * Verifica se o usuário pertence a um grupo do Cognito.
 * @param {object|null} user
 * @param {string} groupName
 * @returns {boolean}
 */
export const hasCognitoGroup = (user, groupName) => {
  if (!groupName) {
    return false;
  }

  return getCognitoGroups(user).includes(groupName);
};
